module.exports = __webpack_public_path__ + "img/subfoldericon.d88c695e.svg";